import React from "react";
import { BingoCell } from "../BingoCell";
import { BingoCell as BingoCellType, WordStats } from "../../../types";
import "./BingoBoard.css";

interface BingoBoardProps {
  gridSize: number;
  cells: BingoCellType[];
  winningIndices?: number[] | null;
  wordStats?: WordStats[];
  onCellToggle: (cellId: string) => void;
}

export const BingoBoard: React.FC<BingoBoardProps> = ({
  gridSize,
  cells,
  winningIndices,
  wordStats = [],
  onCellToggle,
}) => {
  const winningSet = new Set(winningIndices || []);

  // Create a map of text to clickCount for easy lookup
  const clickCountMap = new Map<string, number>();
  wordStats.forEach((stat) => {
    clickCountMap.set(stat.text, stat.clickCount);
  });

  return (
    <div
      className="bingo-board"
      style={{
        gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
        gridTemplateRows: `repeat(${gridSize}, 1fr)`,
      }}
    >
      {cells.map((cell, index) => (
        <BingoCell
          key={cell.id}
          text={cell.text}
          marked={cell.marked}
          isWinning={winningSet.has(index)}
          index={index}
          gridSize={gridSize}
          clickCount={clickCountMap.get(cell.text) || 0}
          onToggle={() => onCellToggle(cell.id)}
        />
      ))}
    </div>
  );
};
